import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowFullLeft = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8.99999 20L32.5385 20",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "square",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M20.4615 8L8.46155 20L20.4615 32",
		stroke: "currentColor",
		strokeWidth: 2
	})]
});
const ForwardRef = forwardRef(SvgArrowFullLeft);
export default ForwardRef;
